import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { LEGAL_DOCUMENTS, LegalDoc } from './legalContent';
import './LegalPage.scss';

interface LegalPageProps {
  doc: LegalDoc;
}

const LegalPage: React.FC<LegalPageProps> = ({ doc }) => {
  const { formatMessage: t } = useIntl();
  const content = LEGAL_DOCUMENTS[doc];

  useEffect(() => {
    document.title = `${content.title} · Holistick`;
  }, [content.title]);

  return (
    <main className="legal-page">
      <article className="legal-page__card">
        <Link className="legal-page__back" to="/">{t({ id: 'legal.back' })}</Link>
        <h1 className="legal-page__title">{content.title}</h1>
        <p className="legal-page__updated">Last updated {content.updated}</p>
        <p className="legal-page__intro">{content.intro}</p>

        {content.sections.map(section => (
          <section key={section.heading} className="legal-page__section">
            <h2>{section.heading}</h2>
            {section.bullets && (
              <ul>
                {section.bullets.map(item => <li key={item}>{item}</li>)}
              </ul>
            )}
            {section.paragraphs?.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}

        <nav className="legal-page__links">
          <Link to="/privacy">{t({ id: 'legal.privacy' })}</Link>
          <span aria-hidden="true">·</span>
          <Link to="/terms">{t({ id: 'legal.terms' })}</Link>
        </nav>
      </article>
    </main>
  );
};

export default LegalPage;
